/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyProjectsIcon = createIcon("EmptyProjectsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "121",
    height: "120",
    viewBox: "0 0 121 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 120c33.137 0 60-26.863 60-60S93.637 0 60.5 0 .5 26.863.5 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M54.5 93c15.464 0 28-12.536 28-28s-12.536-28-28-28-28 12.536-28 28 12.536 28 28 28Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 87c14.912 0 27-12.088 27-27s-12.088-27-27-27-27 12.088-27 27 12.088 27 27 27Z",
    fill: "#fff",
    stroke: "#171717",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.044 62.137-3.712.53.53-3.712 9.546-9.546a2.25 2.25 0 013.182 3.182l-9.546 9.546Z",
    stroke: "#665AF4",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.25 56.25v13.5a1.5 1.5 0 01-1.5 1.5h-19.5a1.5 1.5 0 01-1.5-1.5v-16.5a1.5 1.5 0 011.5-1.5h10.5",
    stroke: "#665AF4",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 54.75h-5.25v13.5h16.5v-9m-16.5 0h3",
    stroke: "#665AF4",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.75 65.25h4.5v3m7.5-3h4.5m-3-3h3",
    stroke: "#665AF4",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "i18nKey": "svg.EmptyProjectsIcon"
});